<template>
  <div class="employment">
    <div class="base-search">
      <el-button
        type="success"
        icon="el-icon-plus"
        @click="addEvent"
        style="background: #623aa2; border: none"
      >
        新增
      </el-button>
      <el-button type="danger" icon="el-icon-delete" @click="deleteAll">批量删除</el-button>
      <el-input
        placeholder="请输入内容"
        v-model="listQuery.keyword"
        class="input-with-select"
        @keyup.enter.native="search"
        clearable
        @clear="search"
        style="width: 240px"
      >
        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
      </el-input>
    </div>
    <div class="base-table">
      <el-table
        ref="multipleTable"
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
        class="table"
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>

        <el-table-column
          type="index"
          :index="
            index => {
              return index + (listQuery.page - 1) * listQuery.pageSize + 1;
            }
          "
          label="序号"
          align="center"
        ></el-table-column>
        <el-table-column label="专家姓名" align="center" prop="name"></el-table-column>
        <el-table-column label="头像" align="center" prop="headImgUrl">
          <template slot-scope="{ row }">
            <div v-if="row.headImgUrl">
              <el-image :src="imgUrl + row.headImgUrl" style="width: 75px; height:100px;" />
            </div>
          </template>
        </el-table-column>
        <el-table-column label="从事专业领域" align="center" prop="techFieldName"></el-table-column>
        <el-table-column label="工作单位" align="center" prop="workCompany"></el-table-column>
        <el-table-column label="备注" align="center" prop="remark"></el-table-column>

        <el-table-column width="240px" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              class="mini_btn"
              size="mini"
              type="primary"
              @click="handleEdit(scope.$index, scope.row)"
            >
              编辑
            </el-button>
            <el-button
              class="mini_btn"
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      @current-change="handleCurrentChange"
      layout="total, prev, pager, next,jumper"
      :total="total"
      :current-page.sync="listQuery.page"
      style="text-align:left;margin:20px 0"
      :page-size="listQuery.pageSize"
    ></el-pagination>
    <el-dialog
      :title="Title"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      v-if="dialogFormVisible"
    >
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="120px">
        <el-row>
          <el-row>
            <el-form-item label="姓名" prop="name">
              <el-input v-model="ruleForm.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="头像" prop="headImgUrl">
              <el-upload
                class="avatar-uploader"
                :action="this.uploadURL"
                name="file"
                :show-file-list="false"
                :on-success="handlePictureCardPreview"
                :before-upload="beforeAvatarUpload"
              >
                <img
                  v-if="ruleForm.headImgUrl"
                  :src="imgUrl + ruleForm.headImgUrl"
                  class="img_border"
                />
                <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                  :class="{ is_border: !ruleForm.headImgUrl }"
                ></i>
                <span class="upload_btn" v-if="!ruleForm.headImgUrl">上传图片</span>
                <span v-else class="upload_btn">更换图片</span>
              </el-upload>
              <span class="del_img" v-show="ruleForm.headImgUrl">
                <i class="el-icon-error" @click="deleteImg"></i>
              </span>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="专业领域" prop="techFieldId">
              <el-select
                style="width: 100%"
                v-model="ruleForm.techFieldId"
                placeholder="请选择"
                @change="changeTalent"
              >
                <el-option
                  v-for="item in lingyuList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="研究方向" prop="researchDir">
              <el-input v-model="ruleForm.researchDir" placeholder="请输入研究方向"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="所属地区" prop="postalAddressDistinguish">
              <el-select
                style="width: 100%"
                v-model="ruleForm.postalAddressDistinguish"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in areaList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="工作单位" prop="workCompany">
              <el-input v-model="ruleForm.workCompany" placeholder="请输入工作单位"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="技术职称" prop="techTitleId">
              <el-select
                style="width: 100%"
                @change="changeTechFieldId"
                v-model="ruleForm.techTitleId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in jishuList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="备注" prop="remark">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入备注"
                v-model="ruleForm.remark"
              ></el-input>
            </el-form-item>
          </el-row>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeForm('ruleForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" v-show="dialogType === 'add'">
          确 定
        </el-button>
        <el-button
          type="primary"
          @click="updateSubmitForm('ruleForm')"
          v-show="dialogType === 'edit'"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import { areaList } from './components/options'

export default {
  data() {
    return {
      dialogType: '',
      listQuery: {
        keyword: '',
        is_page: 0,
        page: 1,
        pageSize: 10
      },
      deleteRow: [],
      lingyuList: [],
      jishuList: [],
      areaList: areaList,
      total: 10,
      Title: "",
      searchValue: "",
      dialogFormVisible: false,
      dialogVisible: false,
      tableData: [],
      ruleForm: {
        name: '',
        postalAddressDistinguish: '',
        headImgUrl: '',
        techFieldId: '',
        techFieldName: '',
        researchDir: '',
        workCompany: '',
        techTitleId: '',
        techTitleName: '',
        remark: ''
      },
      rules: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" }
        ],
        headImgUrl: [
          { required: true, message: "请上传头像", trigger: "change" }
        ],
        techTitleId: [
          { required: true, message: "请选择技术职称", trigger: "change" }
        ],
        techFieldId: [
          { required: true, message: "请选择技术领域", trigger: "change" }
        ],
        postalAddressDistinguish: [
          { required: true, message: "请选择所属地区", trigger: "change" }
        ],
        engagedFieldId: [
          { required: true, message: "请选择从事领域", trigger: "change" }
        ],
        researchDir: [
          { required: true, message: "请输入研究方向", trigger: "blur" }
        ],
        workCompany: [
          { required: true, message: "请输入工作单位", trigger: "blur" }
        ]
      },
    };
  },
  created() {
    this.getSiftList('resource_engaged_field', 'resource_expert_technical_titles')
    this.getData();
  },
  methods: {
    deleteImg() {
			this.$confirm("确定删除图片吗?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
					center: true,
				})
				.then(() => {
					this.ruleForm.headImgUrl = "";
					this.$message({
						type: "success",
						message: "删除成功!",
					});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消删除",
					});
				});
		},
    // 人才类别和从事技术领域
    getSiftList(type1, type2) {
      this.http.post(`${this.urlConfig.devUrl}apij2/admin-api/system/dict-data/getGroup`, {
        dictTypes: [type1, type2]
      }).then(res => {
        if (res.code === 0) {
          const {resource_engaged_field, resource_expert_technical_titles} = res.data;
          this.lingyuList = [
              ...resource_engaged_field
            ]

          this.jishuList = [
              ...resource_expert_technical_titles
            ]
        }
      })
    },
    getData() {
    	this.http.post(this.urlConfig.devUrl+'apij2/admin-api/voucher/resource-industry-expert/page',this.listQuery).then(res =>{
				if (res.code == 0) {
					this.tableData = res.data.data;
					this.total = res.data.total;
				}
			})
    },
    //新增
    addEvent() {
      if (this.$refs["ruleForm"]) {
        this.$refs["ruleForm"].resetFields();
      }
      this.dialogFormVisible = true;
      this.Title = "新增";
      this.dialogType = 'add'

      this.ruleForm = {
        name: '',
        postalAddressDistinguish: '',
        headImgUrl: '',
        techFieldId: '',
        techFieldName: '',
        researchDir: '',
        workCompany: '',
        techTitleId: '',
        techTitleName: '',
        remark: ''
      };
    },
    handlePictureCardPreview(file) {
			console.log(file);
			// this.ruleForm.headImgUrl = file;
			this.ruleForm.headImgUrl = file.data.store_result;
		},
		beforeAvatarUpload(file) {
			let type = false;
			if (
				file.type === "image/jpeg" ||
				file.type === "image/png" ||
				file.type === "image/jpg" ||
				file.type === "image/gif" ||
				file.type === "image/bmp"
			) {
				type = true;
			}

			const isLt2M = file.size / 1024 / 1024 < 30;
			if (!type) {
				this.$message.error("上传图片只能是 JPEG/jpg/png/gif/bmp 格式!");
			}
			if (!isLt2M) {
				this.$message.error("上传图片大小不能超过 30MB!");
			}
			return type && isLt2M;
		},
    	//选择页码
			handleCurrentChange(e) {
				this.listQuery.page = e;
				this.getData();
			},
  		//批量删除
    deleteAll() {
			if (this.deleteRow.length) {
				this.$confirm("此操作将批量删除, 是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
						center: true,
					})
					.then(() => {
						this.http
            .request(this.urlConfig.devUrl + "apij2/admin-api/voucher/resource-industry-expert/delete", {
              ids: this.deleteRow
            }, "delete")
            .then((res) => {
              if (res.code == 0) {
                this.listQuery.page = 1;
                this.getData();
                this.$message({
                  type: "success",
                  message: "删除成功",
                });
                this.ResetSearch(["searchValue"]);
              } else {
                this.$message({
                  message: "失败！",
                  type: "error",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });

			} else {
        this.$message({
					type: "warning",
					message: "请选择删除的记录",
				});
      }
		},
    //搜索
    search() {
      this.listQuery.page = 1;
      this.getData();
    },
    //选择
    selectionChange(selection) {
      this.deleteRow = [];
      if (selection.length != 0) {
        let arr = [];
        selection.forEach((item) => {
          arr.push(item.id);
        });
        this.deleteRow = arr;
      }
    },
    //编辑
    handleEdit(index, row) {
      this.dialogFormVisible = true;
      this.Title = "编辑";
      this.ruleForm = JSON.parse(JSON.stringify(row));
      this.dialogType = 'edit'
    },
    //删除
    handleDelete(index, row) {
      const data = [
        row.id
      ]
      this.$confirm("此操作将批量删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.http
            .request(this.urlConfig.devUrl + "apij2/admin-api/voucher/resource-industry-expert/delete", {
              ids: data
            }, "delete")
            .then((res) => {
              if (res.code == 0) {
                this.listQuery.page = 1;
                this.getData();
                this.$message({
                  type: "success",
                  message: "删除成功",
                });
              } else {
                this.$message({
                  message: "失败！",
                  type: "error",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //取消
    closeForm(name) {
      this.dialogFormVisible = false;
      this.$refs[name].resetFields();
    },
    // 人才
    changeTalent(id) {
      console.log('id')
      const data = this.lingyuList.find(item => item.id == id);
      this.ruleForm.techFieldName = data.label;
    },
    // 技术领域
    changeTechFieldId(id) {
      const data = this.jishuList.find(item => item.id == id);
      this.ruleForm.techTitleName = data.label;
    },
    addData() {
      this.http.post(`${this.urlConfig.devUrl}apij2/admin-api/voucher/resource-industry-expert/create`, this.ruleForm).then(res => {
        if (res.code === 0) {
          this.getData()
          this.dialogFormVisible = false;
          this.$message.success('新增成功');
        } else {
          this.$messgae.error('新增失败')
        }
      }).catch(e => {
        this.$messgae.error('新增失败')
      })
    },
    editData() {
      this.http.put(`${this.urlConfig.devUrl}apij2/admin-api/voucher/resource-industry-expert/update`, this.ruleForm).then(res => {
        if (res.code === 0) {
          this.getData()
          this.dialogFormVisible = false;
          this.$message.success('编辑成功');
        } else {
          this.$messgae.error('编辑失败')
        }
      }).catch(e => {
        this.$messgae.error('编辑失败')
      })
    },
    //提交
    submitForm(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          // 新增提交
          this.addData()
        } else {
          return false;
        }
      });
    },
    updateSubmitForm(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          // 编辑提交
          this.editData()
        } else {
          return false;
        }
      });
    }
  },
};
</script>

<style scoped lang="scss">
.employment {
  height: 100%;
  width: 100%;
  .base-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    /deep/.el-input--suffix {
      width: 100%;
      margin: 0 15px;
    }
    .el-input {
      // width: 400px;
      margin: 0 15px;
    }
    .date-picker {
      margin: 0 15px;
      .el-range-separator {
        width: auto;
      }
    }
  }
  .base-table {
    width: 100%;
    margin-top: 20px;
    border: 1px solid #eef1f6;
  }
}
/*上传图片*/
.is_border {
  border: 1px dashed #ddd !important;
  border-radius: 5px;
  height: 154px !important;
  line-height: 154px !important;
}

.upload_btn {
  display: block;
  background-color: #00a1ff;
  font-weight: bold;
  color: #fff;
  padding: 2px;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}

.upload_btn:hover {
  background-color: #13ce66;
}

.del_img {
  position: absolute;
  top: -7px;
  left: 224px;
  color: #00a1ff;
}

.del_img:hover {
  cursor: pointer;
  color: #f00;
}

.del_img i:before {
  font-size: 20px;
}

.img_border {
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  width: 243px;
  height: 154px;
  display: block;
}

.avatar-uploader {
  text-align: center;
  width: 243px;
  height: 198px;
}

/deep/ .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/ .el-upload:hover {
  border-color: #409eff !important;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 243px;
  height: 154px;
  line-height: 154px;
  text-align: center;
}
</style>
